// extracted by mini-css-extract-plugin
export default {"list":"AvailabilityForm_list__9Z-Kg"};